import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';

export const AuthFields = styled.div`
  ${media.w.min.px992(css`
    max-width: 20.625rem;
  `)};
`;
